module.exports = __webpack_public_path__ + "static/media/MT12.b46c74e6.mp3";